import _extends from "@babel/runtime/helpers/extends";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["content", "iconType", "id", "isLoading", "linkLabel", "onLinkClick", "testID", "UNSAFE_containerProps"];
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
import React from 'react';
import { DesignContextForwardProvider, useDesignContext } from '@klarna/designtokens';
import View from '@bubble-ui/primitive-view';
import Text from '@bubble-ui/primitive-text';
import Link from '@bubble-ui/molecule-link';
import Loader from '@bubble-ui/molecule-loader';
import { useDesignVersion } from '@bubble-ui/provider-design-version';
import withProvisionalOverrideFromContext from '@bubble-ui/hoc-with-provisional-override-from-context';
import useStyleSheet from '@bubble-ui/hook-use-stylesheet';
import { isNative } from '@bubble-ui/util-platform';
import useDeprecationWarning from '@bubble-ui/hook-use-deprecation-warning';
import { usePropsSpreadingDeprecationWarning } from '@bubble-ui/hook-use-props-spreading-deprecation-warning';
import { defaultDesignTokens } from './defaultDesignTokens';
import { getDefaultStyleSheet } from './getDefaultStyleSheet';
import { getIds } from './getIds';
export default function baseAlertBanner(displayName, status, defaultIconType) {
  var Banner = _ref => {
    var {
        content,
        iconType,
        id,
        isLoading,
        linkLabel,
        onLinkClick,
        testID,
        UNSAFE_containerProps
        /**
         * @deprecated props spreading is outdated and will be removed with v7.0.0
         */
      } = _ref,
      props = _objectWithoutProperties(_ref, _excluded);
    useDeprecationWarning({
      componentName: displayName,
      removalDate: 'v7.0.0',
      useInstead: status === 'default' ? 'Toast' : "Toast' with status='".concat(status)
    });
    usePropsSpreadingDeprecationWarning({
      componentName: displayName,
      props,
      useInstead: 'UNSAFE_containerProps',
      removalDate: 'v7.0.0'
    });
    var designContext = useDesignContext(defaultDesignTokens);
    var designVersion = useDesignVersion();
    var color = designContext.get('alert-banner/background-color', {
      status
    }).toString();
    var ids = getIds(id);
    var IconType = iconType || defaultIconType;
    var {
      linkWrapperStyle,
      rootStyle,
      iconStyle,
      paragraphStyle,
      paragraphSecondaryBlockStyle,
      loaderWrapperStyle
      // ⚠️ THIS COMPONENT SUPPORTS STYLE SHEET OVERRIDES ⚠️
      // Keep passing all props to the style sheet, even if we don't use them ourselves
    } = useStyleSheet(Banner, getDefaultStyleSheet, _objectSpread(_objectSpread({}, props), {}, {
      color,
      content,
      designContext,
      designVersion,
      iconType,
      id,
      isLoading,
      linkLabel,
      onLinkClick,
      testID
    }));
    return /*#__PURE__*/React.createElement(View, _extends({
      id: ids === null || ids === void 0 ? void 0 : ids.root,
      testID: testID
    }, UNSAFE_containerProps, {
      style: rootStyle
    }, props), /*#__PURE__*/React.createElement(View, {
      id: ids === null || ids === void 0 ? void 0 : ids.icon,
      style: iconStyle
    }, /*#__PURE__*/React.createElement(DesignContextForwardProvider, {
      context: designContext
    }, /*#__PURE__*/React.createElement(IconType, {
      colorToken: "alert-banner/text-color"
    }))), /*#__PURE__*/React.createElement(View, {
      id: ids === null || ids === void 0 ? void 0 : ids.paragraphWrapper,
      style: paragraphStyle
    }, /*#__PURE__*/React.createElement(Text, _extends({}, isNative ? {
      numberOfLines: 0
    } : {}, {
      tag: "paragraph",
      style: paragraphSecondaryBlockStyle,
      id: ids === null || ids === void 0 ? void 0 : ids.paragraph
    }), content)), isLoading ? /*#__PURE__*/React.createElement(View, {
      id: ids === null || ids === void 0 ? void 0 : ids.loaderWrapper,
      style: loaderWrapperStyle
    }, /*#__PURE__*/React.createElement(Loader, null)) : linkLabel && /*#__PURE__*/React.createElement(View, {
      id: ids === null || ids === void 0 ? void 0 : ids.linkWrapper,
      style: linkWrapperStyle
    }, /*#__PURE__*/React.createElement(Text, _extends({}, isNative ? {
      numberOfLines: 0
    } : {}, {
      tag: "paragraph",
      style: paragraphSecondaryBlockStyle
    }), /*#__PURE__*/React.createElement(DesignContextForwardProvider, {
      context: designContext
    }, /*#__PURE__*/React.createElement(Link, {
      onPress: onLinkClick,
      id: ids === null || ids === void 0 ? void 0 : ids.link,
      colorToken: "alert-banner/text-color",
      textToken: "alert-banner/text-style",
      isUnderlined: true
    }, linkLabel)))));
  };
  Banner.displayName = displayName;
  return withProvisionalOverrideFromContext(Banner);
}
//# sourceMappingURL=index.js.map